
import { ComponentProps, FC } from 'react'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'

// UTILITIES
import { flatten } from '@utils/string-helper'

type ButtonProps = ComponentProps<typeof Button>
interface AddToWalletButtonProps extends ButtonProps {
    cardId?: string
    lastFour?: string
    returnUrl?: string
}

const AddToWalletButton: FC<AddToWalletButtonProps> = ({ className, style, cardId, lastFour, returnUrl, ...props }) => {
    return (
        <Button
            className={flatten('flex flex-row items-center gap-4', className)}
            style={{ justifyContent: 'center', ...style }}
            to='/wallet-explainer'
            navOptions={{ state: { cardId, lastFour, returnUrl } }}
            theme="dark"
            {...props}
        >
            <Icons.Wallet tint="var(--splitcard-white)" />
            Add To Apple Wallet
        </Button>
    )
}

export default AddToWalletButton
